import { STORAGE } from './enums/storage.enum';
import { THEME_MODE } from './enums/theme.enum';

export const storagePersist = () => {
  const currentTheme = localStorage.getItem(STORAGE.Theme_key);
  const currentScreen = localStorage.getItem(STORAGE.Current_screen);
  const currentSubmenu = localStorage.getItem(STORAGE.Submenu);

  localStorage.clear();
  currentTheme === THEME_MODE.dark
    ? localStorage.setItem(STORAGE.Theme_key, THEME_MODE.dark)
    : localStorage.setItem(STORAGE.Theme_key, THEME_MODE.light);
  currentScreen && localStorage.setItem(STORAGE.Current_screen, currentScreen);
  currentSubmenu && localStorage.setItem(STORAGE.Submenu, currentSubmenu);
};
